import React  from 'react';
import Layout from './Layout'
export default function Events({ data }) {
    return (
        <div className='events wrapper'>
            {data.map((item, index) => <div key={index} className='item'><Layout  {...item} /></div>)}
        </div>
    );
}